import { useCallback } from 'react';
import { useCustomers } from '../../api/hooks/customers/useCustomers';
import { UpgradeRequiredBanner } from '../../components/atoms/UpgradeRequiredBanner';
import { EntityPaginationData } from '../../components/molecules/EntityPaginationData';
import { SORT_BY_CUSTOMERS, SUBSCRIPTION } from '../../interfaces/enumerables';
import { getCustomersSortByFilter } from '../../services/utils/sortData';
import { useHasActivePlan } from '../../services/utils/useHasActivePlan';
import { usePlanIsActive } from '../../services/utils/usePlanIsActive';
import { CustomerItemCard } from './components/CustomerItemCard';

export const CustomersScreen = () => {
  const showSubtotals = usePlanIsActive(SUBSCRIPTION.SUBTOTALS);
  const hasActivePlan = useHasActivePlan(false, SUBSCRIPTION.SIMPLE_V1);
  const sortByFilter = useCallback(() => getCustomersSortByFilter(showSubtotals), [showSubtotals]);

  return (
    <EntityPaginationData
      useDataHook={useCustomers}
      ItemCardData={CustomerItemCard}
      sortByFilter={sortByFilter()}
      hideCreateButton={!hasActivePlan}
      sortByDefaultKey={SORT_BY_CUSTOMERS.COMPANY_NAME}
      headerSlot={!hasActivePlan ? <UpgradeRequiredBanner /> : undefined}
    />
  );
};
